import { useEffect } from 'react'
import { SITE_URL } from '../config/appLinks'

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

const setCanonical = href => {
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/**
 * Title, description, canonical URL and robots for the current page (the
 * site is a client-rendered SPA; index.html carries the same defaults for
 * crawlers that do not run JavaScript).
 */
export default function useDocumentMeta({ title, description, path, robots } = {}) {
  useEffect(() => {
    if (title) {
      document.title = title
      setMeta('property', 'og:title', title)
      setMeta('name', 'twitter:title', title)
    }
    if (description) {
      setMeta('name', 'description', description)
      setMeta('property', 'og:description', description)
      setMeta('name', 'twitter:description', description)
    }
    if (path) {
      const url = `${SITE_URL}${path === '/' ? '/' : path}`
      setCanonical(url)
      setMeta('property', 'og:url', url)
    }
    if (robots) setMeta('name', 'robots', robots)
  }, [title, description, path, robots])
}
